import { SET_FORM_VALUE, UNSET_FORM_VALUE } from '@/redux/actions/formValues.actions'

const initalState = {}

const reducer = (state = initalState, action) => {
	switch (action.type) {
		case SET_FORM_VALUE: {
			const key = `${(action.payload.formId ? `${action.payload.formId}-` : '') + action.payload.fieldName}`
			return { ...state, [key]: action.payload.value }
		}
		case UNSET_FORM_VALUE: {
			const key = `${(action.payload.formId ? `${action.payload.formId}-` : '') + action.payload.fieldName}`

			return Object.keys(state).reduce((obj, id) => {
				if (id !== key) {
					return {
						...obj,
						[id]: state[id]
					}
				}
				return obj
			}, {})
		}
		default:
			return state
	}
}

export default {
	name: 'formValues',
	onlyReducer: reducer
}
